////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { Field } from 'redux-form';
import renderField from './renderField'
import './renderField.css'


const EntitySelector = ({ input, meta: { touched, error } }) => (
    <div>
      <select {...input}>
        <option value="">Select entity type...</option>
        <option value="indiv">Individual or sole trader</option>
        <option value="corp">Incorporated association</option>
        <option value="limit">Limited company/PLC</option>
        <option value="localgov">Local government</option>
        <option value="nhsenglnad">NHS England and Wales</option>
        <option value="nhsireland">NHS Northern Ireland</option>
        <option value="crown">Crown</option>
        <option value="nhsscotland">NHS Scotland</option>
        <option value="nonukcomany">Non-UK company/PLC</option>
        <option value="nonukgov">Non-UK government/ administration</option>
        <option value="partnership">Partnership</option>
        <option value="publicbody">Public body</option>
        <option value="charity">Registered charity</option>
        <option value="gov">Government</option>
        <option value="unincorporatedassociation">Unincorporated association</option>
        <option value="university">University/educational</option>
        <option value="communityinterest">Community interest</option>
        <option value="charter">Royal charter</option>
        <option value="religious">Religious body</option>
        <option value="legal">Other legal entity</option>
      </select>
      {touched && error && <span className="input-error">{error}</span>}
    </div>
  )


class TddFormPage extends Component {


  renderError = ({ meta: { touched, error } }) =>
    touched && 
    error ? <span>{error}</span> : false



  render(){
    var {  entity, existingcustomer } = this.props;

    return (
<React.Fragment>
          {/*<center><h4>Welcome first time user! Please enter profile information</h4></center>*/}
                <div>
        <div>
          <label style={{ width: "800px"}}><Field name="existingcustomer" component="input" type="radio" value="true"/> I am an existing customer and I have an Ofcom customer reference number</label>
          <label style={{ width: "800px"}}><Field name="existingcustomer" component="input" type="radio" value="false"/>I am a new customer</label>
          <Field name="existingcustomer" component={({ meta: { touched, error } }) =>
  touched && 
  error ? <span>{error}</span> : false
} />
        </div>
      </div>
          { existingcustomer ==="true" && <Field
            name="customernumber"
            type="text"
            component={renderField}
            label="Ofcom Customer Reference Number"
            placeholder="If you are an existing licensee, enter your customer reference number"
          />}
      { existingcustomer ==="false" && <div><label>Organisation Type </label><Field name="entity" component={EntitySelector} /></div> }
      {  existingcustomer ==="false" && (entity==="indiv" || entity==="partnership") && <Field
            name="name"
            type="text"
            component={renderField}
            label="Full name"
            placeholder="Enter your full name"
          />}
      {  existingcustomer ==="false" && (entity==="limit" || entity==="nonukcomany" || entity==="corp") && <React.Fragment>
          <Field
            name="companyname"
            type="text"
            component={renderField}
            label="Company Name"
            placeholder="Enter the company name"
          />
          <Field
            name="companyregnumber"
            type="text"
            component={renderField}
            label="Company Registration Number"
            placeholder="Enter the company registration number"
          /> </React.Fragment>}
      {  existingcustomer ==="false" && entity==="charity" && <React.Fragment>
          <Field
            name="charityname"
            type="text"
            component={renderField}
            label="Charity Name"
            placeholder="Enter the charity name"
          />
          <Field
            name="charityregnumber"
            type="text"
            component={renderField}
            label="Charity Registration Number"
            placeholder="Enter the charity registration number"
          />
          <div>
            <label>Does the registered charity have as as its objective, the safety of human life in an emergency?</label>
            <div>
            <Field name="humansafety" id="humansafety" component="input" type="checkbox"/>
            </div>
            </div>
          </React.Fragment>}
        {  existingcustomer ==="false" && entity==="legal" && <React.Fragment>
          <Field
            name="legalentityname"
            type="text"
            component={renderField}
            label="Legal Entity Name"
            placeholder="Enter the legal entity name"
          />
          <Field
            name="regnumber"
            type="text"
            component={renderField}
            label="Registration Number(where applicable)"
            placeholder="Enter the legal entity registration number"
          /></React.Fragment>}
</React.Fragment>
    );
  };

}

export default TddFormPage



